import dateFormatNames from '../cldr/date-format-names';
import dateNameType from './date-name-type';

export default function formatNames(locale, type, formatLength, standAlone, lower) {
    return dateFormatNames(locale, {
        type: type,
        nameType: dateNameType(formatLength),
        standAlone: standAlone,
        lower: lower
    });
}
//# sourceMappingURL=format-names.js.map



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@telerik/kendo-intl/dist/es/dates/format-names.js
// module id = ../../../../@telerik/kendo-intl/dist/es/dates/format-names.js
// module chunks = 3